// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0a3911c5","455":"0d6ad9f6","977":"ae34c2ca"}[chunkId] + ".chunk.js";
};